import { render, staticRenderFns } from "./tab-1-profile.vue?vue&type=template&id=3dec6862&scoped=true&lang=pug&"
import script from "./tab-1-profile.vue?vue&type=script&lang=js&"
export * from "./tab-1-profile.vue?vue&type=script&lang=js&"
import style0 from "./tab-1-profile.vue?vue&type=style&index=0&id=3dec6862&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec6862",
  null
  
)

export default component.exports